import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableStateVM, tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import { SplitOrderInvoicesDataItem, SplitOrderInvoicesListPageState } from './split_order_invoices_list_types';
import { splitOrderInvoicesListPageStateVM } from './split_order_invoices_list_view_models';
import {
    SPLIT_ORDER_INVOICES_LIST_FORM_KEY,
    SPLIT_ORDER_INVOICES_LIST_STORAGE_KEY,
} from '../split_order_invoices_const';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { SplitOrderInvoicesSearchModel } from './search/split_order_invoices_search_types';
import { splitOrderInvoicesSearchFormAtom } from './search/split_order_invoices_search_atoms';
import { stripAwayFormErrors } from '../../../core/table/utils/stripAwayFormErrors';

// PAGE
export const splitOrderInvoicesPageStateAtom = atom<SplitOrderInvoicesListPageState>(
    splitOrderInvoicesListPageStateVM(),
);
export const splitOrderInvoicesPageActionAtom = atom(get => get(splitOrderInvoicesPageStateAtom).action);

// TABLE
export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const splitOrderInvoicesDataAtom = atom<TableDataState<SplitOrderInvoicesDataItem>>({
    items: [],
    dataItems: [],
});

export function setAtomSplitOrderInvoicesListTableViewState(atomsDestroyed: boolean = false): void {
    if (atomsDestroyed) return;
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);
    tableViewRepo.setTable(SPLIT_ORDER_INVOICES_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}

export function setAtomSplitOrderInvoicesFormState(): void {
    const defaultStore = getDefaultStore();
    const formState = defaultStore.get<SplitOrderInvoicesSearchModel>(splitOrderInvoicesSearchFormAtom);
    tableViewRepo.setForm(SPLIT_ORDER_INVOICES_LIST_FORM_KEY, stripAwayFormErrors(formState));
}
